export default __webpack_public_path__ + "static/media/saveBtn.6cbc5a3d.svg";